<template>
  <div class="all-whole">
    <navCom :navActive="navActive"></navCom>
    <div class="w clearfix">
      <!--左侧导航 start-->
      <about-user :aboutUserNav="aboutUserNav"></about-user>
      <!--左侧导航 end-->
      <!--右侧内容 start-->
      <div class="user-main-right">
        <h2 class="user-order-title">学校简介</h2>
        <div class="about-us-main"  v-html='content'>{{content}}</div>
      </div>
      <!--右侧内容 end-->
    </div>
    <footerCom></footerCom>
  </div>
</template>

<script>
  import AboutUser from '.././components/about-user.vue'
  import navCom from '../../components/welcome-nav'
  import footerCom from '../../components/foot'
  import tool from '../../assets/js/tool.js'
  export default {
    name: "brief",
    data(){
      return{
        navActive:5,
        aboutUserNav:1,
        companyInfo:{},//公司简介
        content:''
      }
    },
    components: {
        AboutUser,
        navCom,
      footerCom
    },
    methods:{
      getContent () {
        let data = {};
        tool.postData('About/index', data,(res) => {//底部信息
            this.content= res.data.data.content;
          },
        );
      },
    },
    mounted(){
      this.getContent()
    }
  }
</script>

<style scoped>
  .w{
    width: 1200px;
    margin: 0 auto;
  }
  .all-whole{
    background: #fbfbfb;
  }
  .user-main-right{
    width: 1000px;
    float: right;
    min-height:720px;
    background: #ffffff;
  }
  .user-order-title{
    width: 100%;
    height: 70px;
    line-height: 100px;
    box-sizing: border-box;
    border-bottom: 1px solid #e3e3e3;
    font-size: 18px;
    color: #252525;
    padding-left: 20px;
    font-weight: 500;
  }
  .about-us-main-img{
    width: 665px;
    margin: 45px auto ;
  }
  /deep/.about-us-main p img{
    width: 100% !important;
  }
  .about-us-main{
    width: 91%;
    margin: 0 auto;
    padding: 20px 0;
  }
  .about-us-title{
    font-size: 20px;
    color: #1a71ff;
    font-weight: 600;
    margin: 30px 0 25px;
  }
  .about-us-title span{
    font-size: 15px;
    color: #7b7b7b;
    margin-left: 9px;
    font-weight: 500;
  }
  .about-us-txt{
    font-size: 16px;
    color: #7e7e7e;
    line-height: 25px;
    text-indent: 30px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/about-user/brief.vue